'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { cn } from '@achra/ui/lib/utils';
import { X } from 'lucide-react';
import { motion } from 'motion/react';
import { useWorkstreamBanner } from './use-workstream-banner';
import { WorkstreamBannerBackground } from './workstream-banner-background';
import { WorkstreamBannerContent } from './workstream-banner-content';
import { WorkstreamBannerOverlay } from './workstream-banner-overlay';
interface WorkstreamBannerProps {
  backgroundImage?: string;
}
function WorkstreamBanner(t0) {
  const $ = _c(22);
  const {
    backgroundImage
  } = t0;
  const {
    isNetworkBanner,
    handleHide,
    animationProps
  } = useWorkstreamBanner();
  let t1;
  if ($[0] !== backgroundImage || $[1] !== isNetworkBanner) {
    t1 = <WorkstreamBannerBackground isNetworkBanner={isNetworkBanner} backgroundImage={backgroundImage} />;
    $[0] = backgroundImage;
    $[1] = isNetworkBanner;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  let t3;
  if ($[3] !== isNetworkBanner) {
    t2 = <WorkstreamBannerContent isNetworkBanner={isNetworkBanner} />;
    t3 = <WorkstreamBannerOverlay isNetworkBanner={isNetworkBanner} />;
    $[3] = isNetworkBanner;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  let t4;
  if ($[6] !== isNetworkBanner) {
    t4 = cn("absolute top-3 right-3 z-20 h-6 w-6", {
      "hover:bg-primary": isNetworkBanner
    });
    $[6] = isNetworkBanner;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = isNetworkBanner ? "text-primary-foreground" : "text-primary";
  let t6;
  if ($[8] !== t5) {
    t6 = cn(t5);
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = <X className={t6} aria-hidden="true" focusable="false" />;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== handleHide || $[13] !== t4 || $[14] !== t7) {
    t8 = <Button variant="ghost" className={t4} onClick={handleHide} aria-label="Close banner">{t7}</Button>;
    $[12] = handleHide;
    $[13] = t4;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== animationProps || $[17] !== t1 || $[18] !== t2 || $[19] !== t3 || $[20] !== t8) {
    t9 = <motion.div className="shadow-primary relative overflow-hidden rounded-xl" {...animationProps}>{t1}{t2}{t3}{t8}</motion.div>;
    $[16] = animationProps;
    $[17] = t1;
    $[18] = t2;
    $[19] = t3;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}
export { WorkstreamBanner };